import{a as n}from"./ninox-components-3BPDSF2O.js";import{hsl as r}from"d3-color";var l=n((t,o)=>{let{h:e,s,l:i}=r(t);return r(e,s,i,o??1).toString()},"alpha");export{l as a};
//# sourceMappingURL=ninox-components-XOQQUUT5.js.map